import React from 'react';

import { useTranslation } from 'react-i18next';

import { Typography } from '../../../DesignSystem';
import YatHandLoader from '../../../YatHandLoader';
import '../NftSidePanel.scss';

export const Processing = () => {
    const { t } = useTranslation(['nft']);

    return (
        <div className="yat-nft-sidebar__step yat-nft-sidebar__loading">
            <div className="yat-nft-sidebar__flex-item">
                <div className="yat-nft-sidebar__hand-loader">
                    <YatHandLoader />
                </div>

                <Typography type="headline" size={20} classes={['yat-nft-sidebar__title']}>
                    {t('visualization_in_progress_title')}
                </Typography>
            </div>
        </div>
    );
};
